import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEyeOpenedLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M3.11 13.404a1 1 0 0 1-1.877-.136l-.696-2.5a1 1 0 0 1 1.926-.536l.104.373c.773-.868 1.733-1.57 2.804-2.117l-.35-1.676a1 1 0 0 1 1.958-.409l.275 1.316A15.5 15.5 0 0 1 11 7.031V5a1 1 0 1 1 2 0v2.03c1.268.078 2.544.304 3.746.689l.275-1.316a1 1 0 1 1 1.958.41l-.35 1.675c1.071.547 2.031 1.25 2.804 2.117l.104-.373a1 1 0 0 1 1.926.536l-.696 2.5a1 1 0 0 1-1.878.136C19.653 10.605 16.001 9 12 9s-7.653 1.605-8.89 4.404'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 10c-1.154 0-2.203.29-2.957 1.043C8.289 11.797 8 12.846 8 14s.29 2.203 1.043 2.957C9.797 17.711 10.846 18 12 18s2.203-.29 2.957-1.043C15.711 16.203 16 15.154 16 14s-.29-2.203-1.043-2.957C14.203 10.289 13.154 10 12 10m-2 4c0-.846.21-1.297.457-1.543.246-.246.697-.457 1.543-.457s1.297.21 1.543.457c.246.246.457.697.457 1.543s-.21 1.297-.457 1.543c-.246.246-.697.457-1.543.457s-1.297-.21-1.543-.457C10.211 15.297 10 14.846 10 14'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgEyeOpenedLine)
export default ForwardRef
